import React from 'react';
import { Link } from 'react-router-dom';
import { Card as MaterialCardUi, CardActions, CardContent, CardHeader, CardMedia } from '@material-ui/core';
import PropTypes from 'prop-types';
import { IconButton } from './buttons';
import { ImageSmall } from './content';
import { EditIcon, PreviewIcon } from './icons';
const Card = _ref => {
  let {
    children,
    title,
    description,
    onEditBtnClick,
    onPreviewBtnClick,
    className,
    avatar,
    image,
    actions = null,
    linkTo = false
  } = _ref;
  const hasCardContentTag = children && children.some(x => x.type.name === CardContent.name);
  const cardContent = children && children.filter(x => x.type.name !== CardActions.name);
  let renderActions = children && children.filter(x => x.type.name === CardActions.name);
  if (!renderActions && actions !== false && (onEditBtnClick || onPreviewBtnClick)) {
    renderActions = /*#__PURE__*/React.createElement(CardActions, null, onEditBtnClick && /*#__PURE__*/React.createElement(IconButton, {
      color: "primary",
      label: "Edit",
      onClick: onEditBtnClick
    }, /*#__PURE__*/React.createElement(EditIcon, {
      size: "small"
    })), onPreviewBtnClick && /*#__PURE__*/React.createElement(IconButton, {
      color: "primary",
      label: "Preview",
      onClick: onPreviewBtnClick
    }, /*#__PURE__*/React.createElement(PreviewIcon, {
      size: "small"
    })));
  }
  return /*#__PURE__*/React.createElement(MaterialCardUi, {
    className: className || ''
  }, linkTo ? /*#__PURE__*/React.createElement(Link, {
    to: linkTo
  }, typeof avatar === 'string' ? /*#__PURE__*/React.createElement(CardHeader, {
    avatar: /*#__PURE__*/React.createElement(ImageSmall, {
      src: avatar,
      alt: title
    }),
    title: title,
    subheader: description
  }) : /*#__PURE__*/React.createElement(CardHeader, {
    title: title,
    subheader: description
  }), image && /*#__PURE__*/React.createElement(CardMedia, {
    src: image,
    image: image,
    title: title
  }), cardContent && (hasCardContentTag ? cardContent : /*#__PURE__*/React.createElement(CardContent, null, cardContent)), renderActions) : /*#__PURE__*/React.createElement(React.Fragment, null, typeof avatar === 'string' ? /*#__PURE__*/React.createElement(CardHeader, {
    avatar: /*#__PURE__*/React.createElement(ImageSmall, {
      src: avatar,
      alt: title
    }),
    title: title,
    subheader: description
  }) : /*#__PURE__*/React.createElement(CardHeader, {
    title: title,
    subheader: description
  }), image && /*#__PURE__*/React.createElement(CardMedia, {
    src: image,
    image: image,
    title: title
  }), cardContent && (hasCardContentTag ? cardContent : /*#__PURE__*/React.createElement(CardContent, null, cardContent)), renderActions));
};
Card.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
  onEditBtnClick: PropTypes.func,
  actions: PropTypes.bool
};
export { Card, CardActions, CardContent };